import * as React from "react";
import * as React44ms from "../../../Util/form-utils/react-44ms";

import {
  PRESENTATION_SCROLL_ACTIONS,
  usePresenterForScroll,
} from "../../providers/presenter-for-scroll-provider";

import { scrollToJustAbove } from "../../scroll";

interface UseScrollToErrorInFormProps {
  cssSelectorBase?: string;
  overrideScrollToCustomField?: () => string | undefined | null;
}

const buildSelector = (
  props: UseScrollToErrorInFormProps,
  elementSelectorFragment: string
) => `${props.cssSelectorBase || ""} ${elementSelectorFragment}`;

const findFirstErrorInForm = (formState: any, whereAmI: string | null) => {
  if (!formState) {
    return null;
  }
  const firstError = Object.keys(formState).find((key) => {
    if (key.toLowerCase().includes("error") && !!formState[key]) {
      return true;
    }
    return false;
  });
  if (firstError) {
    return whereAmI;
  }

  let nestedResult: typeof whereAmI = null;
  Object.keys(formState).forEach((key) => {
    if (!nestedResult && typeof formState[key] === "object") {
      const whereAmI_inThisNest = whereAmI ? `${whereAmI}.${key}` : key;
      const result = findFirstErrorInForm(formState[key], whereAmI_inThisNest);
      if (result) {
        nestedResult = result;
      }
    }
  });

  return nestedResult;
};

export const useScrollToErrorInForm2023 = (
  props: UseScrollToErrorInFormProps
): void => {
  const { scrollActionToTake, onScrollAnimationBegin } =
    usePresenterForScroll();

  const getFormStateCurrent = React44ms.React.useFormRef();

  React.useEffect(() => {
    if (
      scrollActionToTake ===
      PRESENTATION_SCROLL_ACTIONS.SCROLL_TO_FORM_ERROR_FIELD
    ) {
      let scrollToThisElement: Element | null = null;

      if (!scrollToThisElement && props.overrideScrollToCustomField) {
        const customField = props.overrideScrollToCustomField();
        if (customField) {
          const selector = buildSelector(props, customField);
          const element = document.querySelector(selector);
          if (element) {
            scrollToThisElement = element;
          }
        }
      }

      const formState = getFormStateCurrent();
      const firstErrorInForm_location = findFirstErrorInForm(formState, null);
      const errorExpectsInputNamed =
        firstErrorInForm_location?.split(".")?.reverse()?.at(0) || null;
      if (!scrollToThisElement && errorExpectsInputNamed) {
        const selector = buildSelector(
          props,
          `.named-${errorExpectsInputNamed}`
        );
        const element = document.querySelector(selector);
        if (element) {
          scrollToThisElement = element;
        }
      }

      if (scrollToThisElement) {
        scrollToJustAbove(scrollToThisElement);
      }

      onScrollAnimationBegin();
    }
  }, [props, scrollActionToTake]);
};
